import axios from 'axios'
import i18n from '@/plugins/i18n'

// Модель для работы с отчетами по БСО/разрешениями
export default {
  // Получение списка по ООПТ
  getOoptFaunaApplicationBsos (oopt, filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/permitReport/getOoptFaunaApplicationBsos/${oopt}?${filter}`)
  },
  // Получение списка по пользователю
  getUserFaunaApplicationBsos (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/permitReport/getUserFaunaApplicationBsos?${filter}`)
  },
  // Получение данных для формы поиска
  getSearchFormData () {
    return axios.get(`${i18n.locale}/api/permitReport/getSearchFormData`)
  },
  // Получение данных для формы
  getFormData (id) {
    return axios.get(`${i18n.locale}/api/permitReport/getFaunaLicenseApplicationBsosFormData/${id}`)
  },
  // Получение данных
  getFaunaLicenseApplicationBsoData (id) {
    return axios.get(`${i18n.locale}/api/permitReport/getFaunaLicenseApplicationBsoData/${id}`)
  },
  // Создание/редактирование отчета по разрешению
  createEditFaunaLicenseApplicationBsosReports (id, data) {
    return axios.post(`${i18n.locale}/api/permitReport/createEditFaunaLicenseApplicationBsosReports/${id}`, data)
  },
  // Удаление сущности документа
  deleteDocument (id) {
    return axios.delete(`${i18n.locale}/api/permitReport/deleteFaunaLicenseApplicationBsoDocument/${id}`)
  },
  // Получение данных для формы документа
  getDocumentFormData () {
    return axios.get(`${i18n.locale}/api/permitReport/getFaunaLicenseApplicationBsoDocumentFormData`)
  },
  // Получение данных для отображения документа
  showDocument (id) {
    return axios.get(`${i18n.locale}/api/permitReport/getFaunaLicenseApplicationBsoDocumentInfo/${id}`)
  },
  // Создание/обновление документа
  updateDocument (params, data) {
    return axios.post(`${i18n.locale}/api/permitReport/${params.route}/${params.id}`, data)
  },
  // Список действий
  getActions (statusId) {
    return axios.get(`${i18n.locale}/api/permitReport/actions/${statusId}`)
  },
  // Изменение статуса
  changeStatus (id, data) {
    return axios.post(`${i18n.locale}/api/permitReport/changeStatus/${id}`, data)
  },
  // печать в ворд отчета о добыче диких животных
  printWildlifeHuntReport (oopt, year) {
    return axios.get(`${i18n.locale}/api/permitReport/wildlifeHuntReportPrint/${oopt}/${year}`, { responseType: 'arraybuffer' })
  },
  // печать в excel отчета о результатах охоты
  generateHuntingResultReportExcel (year, soate) {
    return axios.get(`${i18n.locale}/api/permitReport/generateHuntingResultReportExcel/${year}/${soate}`, { responseType: 'arraybuffer' })
  },
  // печать в excel журнала БСО
  generateJournalBsoReportExcel (type, year) {
    return axios.get(`${i18n.locale}/api/permitReport/generateJournalBsoExcel/${year}/${type}`, { responseType: 'arraybuffer' })
  }
}
